import { Modal, Box, Typography } from "@mui/material"
import cafgu from "../../../../../../assets/images/core/cafgu.svg"

export const FirstPurchaseModal = ({open, close, order, register})=>{
    const total = order?.orderList?.reduce((sum, item) => sum + item.value * item.price, 0) ;
    return(
        <Modal open={open} onClose={close} sx={{p:2, display: "flex", alignItems: "center"}}>
            <Box sx={{p: 3, display: "flex", flexDirection: "column", gap: 4, justifyContent: "space-between", bgcolor: "#fff", width: "100%", borderRadius: 4}}>
                <Box sx={{display: "flex", flexDirection: "column", gap: 2}}>
                    <Box>
                        {/* <Typography sx={{ fontWeight: 800, textAlign: "center", fontSize: 30, color: "primary.main"}}>CHA-CHING!</Typography> */}
                        <Typography sx={{ fontWeight: 600, textAlign: "center"}}>SALE RECORDED</Typography>
                        <Typography sx={{ fontWeight: 800, textAlign: "center", fontSize: 50, color: "primary.main"}}>₱{total}</Typography>
                    </Box>
                    <Typography sx={{textAlign: "center", fontSize: 14}}>You just made your first digital sale! See how easy that was?</Typography>
                    <Box sx={{bgcolor: "primary.main", width: '100%', px: 2, py: 1, borderRadius: 4, color: "#fff", textAlign: "center"}} onClick={register}>View my report</Box>
                    <Typography sx={{textAlign: "center", fontSize: 14, fontStyle: "italic", textDecoration: "underline"}} onClick={close}>Create new order?</Typography>
                </Box>
            </Box>
        </Modal>
    )  
}

export const ReadyForBusinessModal = ({open, register, close})=>{
    return(
        <Modal open={open} sx={{p:2, display: "flex", alignItems: "center"}}>
            <Box sx={{p: 3, display: "flex", flexDirection: "column", gap: 4, justifyContent: "space-between", bgcolor: "#fff", width: "100%", borderRadius: 4}}>
                <Box sx={{display: "flex", flexDirection: "column", gap: 2}}>
                    <Box sx={{display:"flex", flexDirection: "column", justifyContent: "center", gap: 2}}>
                        {/* <Typography sx={{ fontWeight: 800, textAlign: "center", fontSize: 30, color: "primary.main"}}>CHA-CHING!</Typography> */}
                        <Typography sx={{ fontWeight: 800, textAlign: "center", fontSize: 20, color: "primary.main"}}>There are more things to explore!</Typography>
                        <Box component="img" src={cafgu} sx={{borderRadius: 4, width: 200, margin: "auto"}}/>
                    </Box>
                    <Typography sx={{textAlign: "center", fontSize: 14}}>Create your free account to save your transaction history and keep selling.</Typography>
                    <Box sx={{bgcolor: "primary.main", width: '100%', px: 2, py: 1, borderRadius: 2, color: "#fff", textAlign: "center"}} onClick={register}>View my report</Box>
                    {/* <Typography sx={{textAlign: "center", fontSize: 14}}>or enter your email and continue using POS</Typography> */}
                    <Typography sx={{textAlign: "center", fontSize: 14, fontStyle: "italic", textDecoration: "underline"}} onClick={close}>Create new order?</Typography>
                </Box>
            </Box>
        </Modal>
    )
}